export interface ConfigType {
  env: 'production' | 'integration' | 'development' | 'local';
  apiKey: string;
  clientId: string;
  // oba-auth OAuth2 client id for the document-viewer's own auth (scope sign-documents-SE),
  // separate from the main login clientId above.
  signDocumentsClientId: string;
  clientName: string;
  clientVersion: string;
  clientPlatform: string;
  chatClientId: string;
  requestTimeout: number;
  mockRequestDelay?: number;
  enableLog: boolean;
  customerFrontendService?: string;
  bankIdHost?: string;
  bankIdNoAuthorizeHost?: string;
  signingPathPrefix: string;
  apm: {
    apmEnvironment: string;
    apmServiceName: string;
    apmServerUrl: string;
  };
  links: {
    entrypoint: string;
    unleash: string;
    mbidRefresh: string;
    oAuthToken: string;
    oAuthRedirect: string;
    oAuthTokenRevoke: string;
    oAuthPreAuth: string;
  };
}

let config: ConfigType | undefined = undefined;

export const setConfig = (e: ConfigType) => {
  config = e;
};
export const getConfig = () => config;

export const requireConfig = () => {
  if (!config) throw new Error('config is not defined');
  return config;
};

export default ConfigType;
